
import { defineComponent } from "vue";
import * as navigationGuard from "@/router/navigationGuard";

export default defineComponent({
  name: "Modal",
  props: {
    showModal: Boolean,
    title: String,
    options: {
      default: {
        hideOnEscapeKey: true,
        hideOnClickOutside: true,
        hideOnBrowserBackButton: true,
      },
    },
  },
  emits: ["hide"],
  methods: {
    registerEventListenersAndPreventRoutingWhenModalIsShown() {
      window.addEventListener("click", this.onClick);
      window.addEventListener("keydown", this.hideDrawerOnEscape);
      navigationGuard.preventRouting(this.preventRoutingCallback);
      // TODO: prevent app drawer (only reason it's not needed yet is because modal is only used in views that disable drawer)
    },
    unregisterEventListenersAndAllowRoutingWhenModalIsHidden() {
      window.removeEventListener("click", this.onClick);
      window.removeEventListener("keydown", this.hideDrawerOnEscape);
      navigationGuard.allowRouting(this.preventRoutingCallback);
    },
    onClick(event: Event) {
      if (this.options.hideOnClickOutside === false) return;
      const target = event.target as HTMLElement;
      if (target.classList.contains("bg")) {
        this.$emit("hide");
      }
    },
    hideDrawerOnEscape(event: KeyboardEvent) {
      if (this.options.hideOnEscapeKey === false) return;
      if (event.key === "Escape") {
        this.$emit("hide");
      }
    },
    preventRoutingCallback(): void {
      if (this.options.hideOnBrowserBackButton === false) return;
      this.$emit("hide");
    },
  },
  mounted() {
    if (this.showModal) {
      this.registerEventListenersAndPreventRoutingWhenModalIsShown();
    }
  },
  watch: {
    showModal() {
      if (this.showModal) {
        this.registerEventListenersAndPreventRoutingWhenModalIsShown();
      } else {
        this.unregisterEventListenersAndAllowRoutingWhenModalIsHidden();
      }
    },
  },
});
